import { __assign, __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { DividerWrapper, StyledDivider } from "./styles";
export var Divider = forwardRef(function Divider(_a, ref) {
    var label = _a.label, props = __rest(_a, ["label"]);
    if (label) {
        return (_jsxs(DividerWrapper, { children: [_jsx(StyledDivider, __assign({ ref: ref }, props)), label, _jsx(StyledDivider, __assign({ ref: ref }, props))] }));
    }
    return _jsx(StyledDivider, __assign({ ref: ref }, props));
});
//# sourceMappingURL=index.js.map